import { useEffect, useRef } from "react";

const useSessionLogOut = (
  timestamp,
  timeout = 7200,
  logOutCallback,
  active = false,
  getCurrentTime = () => Math.floor(Date.now() / 1000) // Dependency injection for testability. Jest mock time does not work with Date.now()
) => {
  const timerRef = useRef(null);

  useEffect(() => {
    const checkSessionTimeout = () => {
      const currentTime = getCurrentTime();
      if (timestamp && currentTime - timestamp >= timeout && active) {
        logOutCallback("CLIENT_INACTIVITY_TIMEOUT");
      }
    };

    if (active && timestamp) {
      // Clear any existing timeout before setting a new one
      if (timerRef.current) clearTimeout(timerRef.current);

      const timeRemaining = timeout - (getCurrentTime() - timestamp);

      if (timeRemaining <= 0) {
        logOutCallback("CLIENT_INACTIVITY_TIMEOUT"); // Logout immediately if timeout already exceeded
      } else {
        timerRef.current = setTimeout(
          checkSessionTimeout,
          timeRemaining * 1000
        );
      }
    }

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [timestamp, timeout, logOutCallback, active, getCurrentTime]);
};

export default useSessionLogOut;
